<div id="family-view-container">
    <!--ROW 1: Income Assets, Clients, TBD -->
    <main>
        <section class="flex-row-container m-t25">
            <!--Column 1: Income and Assets -->
            <div class="flex-col-container">
                <!--INCOME-->
                <!-- [matMenuTriggerFor]="incomeMenu"  -->
                <!-- (click)="reloadIncomeSummary();" -->
                <div class="flex-col-container">
                    <mat-card class="mat-card-center profile-panel profile-panel__income pointer m-lr10" 
                        [style.background]="incomeColor"
                        (click)="showIncomeSummaryPanel();$event.stopPropagation()"
                        >
                            <mat-card-content class="ip-center">                                        
                                <div class="flex-col-center">
                                    <span class="font18 m-b10">INCOME</span>

                                    <span  class="font16">{{pName}}</span>
                                    <span  class="font22">{{pEmpIncome && pEmpType!=='NOW' && pEmpType!=='RET'? (pEmpIncome  | currency:'USD': 'symbol' : '1.0-0'): '-'}}</span>
                                    <span  class="font15">{{pEmpType}}</span>

                                    
                                    <span *ngIf="sEmpIncome" class="font18  m-t10">{{sName}}</span>
                                    <span  *ngIf="sEmpIncome" class="font22">{{sEmpIncome && sEmpType!=='NOW' && sEmpType!=='RET'? (sEmpIncome  | currency:'USD': 'symbol' : '1.0-0'): '-'}}</span>
                                    <span *ngIf="sEmpIncome" class="font15">{{sEmpType}}</span>

                                    <!-- <span class="font16  m-t10">Total Income</span>
                                    <span class="font22">{{totalIncome  | currency:'USD': 'symbol' : '1.0-0'}}</span>      -->
                                </div>
                            </mat-card-content>
                    </mat-card>                    
                </div>                            
                <!--ASSETS-->
                <!-- [matMenuTriggerFor]="assetsMenu" -->
                <!--  -->
                <div class="flex-col-container m-t30">
                    <mat-card class="mat-card-center profile-panel profile-panel__assets  pointer m-lr10"
                    [style.background]="assetsColor"
                    (click)="showAssetSummaryPanel();$event.stopPropagation()">
                        <mat-card-content class="ip-center">                                        
                            <div class="flex-col-center">
                                <span class="font18 m-b10">ASSETS</span>

                                <!-- <span *ngIf="!totalTaxableAssets && !totalTaxDefAssets && !totalTaxExemptAssets" class="font16 error">Assets are not included</span> -->

                                <span class="font16" [style.color]="taxableColor">TAXABLE</span>
                                <span class="font22">{{totalTaxableAssets? (totalTaxableAssets  | currency:'USD': 'symbol' : '1.0-0') : '-'}}</span>
                                
                                <span class="font16  m-t10" [style.color]="taxDefColor">TAX-DEFERRED</span>
                                <span class="font22">{{totalTaxDefAssets? (totalTaxDefAssets  | currency:'USD': 'symbol' : '1.0-0') : '-'}}</span>
                                
                                <span class="font16  m-t10" [style.color]="taxExemptColor">TAX-EXEMPT</span>
                                <span class="font22">{{totalTaxExemptAssets? (totalTaxExemptAssets  | currency:'USD': 'symbol' : '1.0-0') : '-' }}</span>
                                
                                
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>        
            </div>
            <!--Column 2: Clients -->
            <div class="flex-col-center m-lr25 flex-1">
                <div class="flex-row-container-wrap">
                    <div *ngFor="let cl of planClients">        
                        <div *ngIf="cl.role==='Primary' || cl.role==='Secondary'" class="flex-col-center m-r50 m-b15">
                            <button mat-fab class="client-initials" style="background-color: var(--neutralPrimary)"
                                [matMenuTriggerFor]="clientMenu" [matMenuTriggerData]="{clientid: cl.clientid}">        
                                <div class="flex-col-center m-t10">
                                    <span>{{cl.initials}}</span>
                                    <span class="font16">{{cl.age?cl.age:'-'}}</span>
                                </div>
                            </button>
                            <span class="m-5 font16">{{cl.clientname}}</span>    
                            <span *ngIf="cl.legalEntityType" class="blueText14" style="margin-top: -8px">({{cl.legalEntityType}})</span>                
                        </div>
                    </div>                    
                </div>
                <!-- Other Clients-->
                <div class="flex-row-container-wrap">
                    <div *ngFor="let cl of planClients">        
                        <div *ngIf="cl.role!=='Primary' && cl.role!=='Secondary'" class="flex-col-center m-r50 m-tb15">
                            <button mat-fab class="client-initials" style="background-color: var(--themePrimaryContrast)"
                                [matMenuTriggerFor]="clientMenu" [matMenuTriggerData]="{clientid: cl.clientid}">        
                                <div class="flex-col-center m-t10">
                                    <span>{{cl.initials}}</span>
                                    <span class="font16">{{cl.age?cl.age:'-'}}</span>   
                                </div>
                            </button>
                            <span class="m-5 font16">{{cl.clientname}}</span>     
                            <span *ngIf="cl.legalEntityType" class="blueText14" style="margin-top: -8px">({{cl.legalEntityType}})</span>               
                        </div>
                    </div>      
                </div>  
                <!-- <div class="flex-row-container-wrap">
                    <div *ngFor="let cl of allClients">        
                        <div class="flex-col-center m-lr15 m-tb10">
                            <button mat-fab class="client-initials1" (click)="includeClientInPlan(cl.LegalEntityID)"
                                [ngStyle]="{'background-color': cl.isIncluded? '#D5D7F2': '#f1f0f0'}"
                                [matMenuTriggerFor]="clientMenu" [matMenuTriggerData]="{clientid: cl.LegalEntityID}">        
                                <div class="flex-col-center m-t10">
                                    <span>{{cl.initials}}</span>
                                    <span *ngIf="cl.age" class="font16">{{cl.age}}</span>
                                </div>
                            </button>
                            <span class="m-5 font16">{{cl.LegalEntityName}}</span>                
                        </div>
                    </div>    
                </div>   -->
            </div>
            <!--Column 3: TBD -->
            <div class="flex-col-container">
                <div class="flex-col-container">                
                    <mat-card class="mat-card-center profile-panel profile-panel__tbd pointer m-lr10" 
                    style="background: #dadba7"
                    [matMenuTriggerFor]="tbdMenu">
                        <mat-card-content class="ip-center">                                        
                            <div class="flex-col-center">
                                <span class="font16 m-b25">TBD</span>

                                <!-- <span class="font14">CARLA KING</span>
                                <span class="font22">{{totalTaxableAssets  | currency:'USD': 'symbol' : '1.0-0'}}</span>
                                
                                <span class="font16  m-t20">JOHN  KING</span>
                                <span class="font22">{{totalTaxDefAssets  | currency:'USD': 'symbol' : '1.0-0'}}</span>                             -->
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
                <div class="flex-col-container m-t30">
                    <mat-card class="mat-card-center profile-panel profile-panel__tbd  pointer m-lr10" 
                    style="background: #dadba7"
                    [matMenuTriggerFor]="tbdMenu">
                        <mat-card-content class="ip-center">                                        
                            <div class="flex-col-center">
                                <span class="font16 m-b25">TBD</span>

                                <!-- <span class="font16">Taxable</span>
                                <span class="font22">{{totalTaxableAssets  | currency:'USD': 'symbol' : '1.0-0'}}</span>
                                
                                <span class="font16  m-t20">Tax Deferred</span>
                                <span class="font22">{{totalTaxDefAssets  | currency:'USD': 'symbol' : '1.0-0'}}</span>
                                
                                <span class="font16  m-t20">Tax Free</span>
                                <span class="font22">{{totalTaxFreeAssets  | currency:'USD': 'symbol' : '1.0-0'}}</span> -->
                                
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>        
            </div>        
        </section>     
    </main>
    <!--ROW 2: GOALS -->
    <footer class="p-tb25">
        <div class="flex-row-center">
            <div *ngFor="let goal of goals;">
                <mat-card  *ngIf="goal.goalId" 
                    class="mat-card-center profile-panel profile-panel__goal pointer m-lr10" 
                    [ngClass]="goal.goalId?'activeGoal':'nonActiveGoal'"
                    [style.background]="'linear-gradient(0.25turn,'+  goal.color +')'"
                    [matMenuTriggerFor]="goal.goalId?goalMenu:''" 
                    [matMenuTriggerData]="{goalid: goal.goalId}" (click)="reloadExpenseSummary();">
                        <mat-card-content class="ip-center">                                        
                            <div class="flex-col-center">
                                <span class="font16 m-b10">{{goal.goalDesc  | uppercase}}</span>
                                <span class="font22">{{goal.amount?(goal.amount  | currency:'USD': 'symbol' : '1.0-0'):'-'}}</span>
                                <!-- <span class="font12">{{goal.goalType!=='LGY'?'per year':'Rest of Life'}}</span> -->
                            </div>
                        </mat-card-content>
                </mat-card>

                <mat-card  *ngIf="!goal.goalId" (click)="addGoalExpense(goal.goalType)"
                class="mat-card-center profile-panel profile-panel__goal pointer m-lr10" 
                [ngClass]="goal.goalId?'activeGoal':'nonActiveGoal'"
                [style.background]="'linear-gradient(0.25turn,'+  goal.color +')'">
                    <mat-card-content class="ip-center">                                        
                        <div class="flex-col-center">
                            <span class="font16 m-b10">{{goal.goalDesc  | uppercase}}</span>
                            <span class="font22">{{goal.amount?(goal.amount  | currency:'USD': 'symbol' : '1.0-0'):'-'}}</span>
                            <!-- <span class="font12">{{goal.goalType!=='LGY'?'per year':'Rest of Life'}}</span> -->
                        </div>
                    </mat-card-content>
            </mat-card>

            </div>
        </div>
    </footer>
</div>

 <mat-menu #clientMenu="matMenu" >
    <ng-template matMenuContent let-clientid="clientid">
        <gp-client-summary [ClientId]="clientid" (click)="$event.stopPropagation();"></gp-client-summary>
    </ng-template>
 </mat-menu>

 <!-- <mat-menu #incomeMenu="matMenu" class="menuIncome">
    <gp-income-summary [Refresh]="refreshInc"></gp-income-summary>        
 </mat-menu> -->


 <div *ngIf="showIncomeSummary" class="incomePanel">
    <gp-income-summary [Refresh]="refreshInc"></gp-income-summary>        
 </div>

 <div *ngIf="showAssetSummary" class="assetPanel">     
    <gp-account-summary [Refresh]="refreshAcc"></gp-account-summary>    
 </div>

 <!-- <mat-menu #assetsMenu="matMenu" class="menuAssets">     
    <gp-account-summary [Refresh]="refreshAcc"></gp-account-summary>    
 </mat-menu> -->

 <mat-menu #goalMenu="matMenu" class="" yPosition="above">
    <!-- <div  style="width: 600px; height: 400px">GOAL</div> -->
    <ng-template matMenuContent let-goalid="goalid">
        <gp-expense-summary [Refresh]="refreshExp" [GoalId]="goalid"></gp-expense-summary>
    </ng-template>
 </mat-menu>

 <mat-menu #tbdMenu="matMenu" class="menuLeft">
    <div  style="width: 600px; height: 400px">TBD</div>
 </mat-menu>

 
 